import { createBrowserRouter, Outlet } from 'react-router-dom';
import { RequireAuth } from './components/RequireAuth';
import { RequireConsent } from './components/RequireConsent';
import { RedirectByOnboarding } from './components/RedirectByOnboarding';
import { AdminGuard } from './components/AdminGuard';
import { HomePage } from './pages/HomePage';
import { BalancePage } from './pages/BalancePage';
import { OnboardingPage } from './pages/OnboardingPage';
import { IdeasPage } from './pages/IdeasPage';
import { IdeaDetailPage } from './pages/IdeaDetailPage';
import { SessionDispatchPage } from './pages/SessionDispatchPage';
import { SessionPage } from './pages/SessionPage';
import { HistoryPage } from './pages/HistoryPage';
import { UniqPage } from './pages/UniqPage';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminIdeasPage } from './pages/admin/AdminIdeasPage';
import { AdminIdeasFormPage } from './pages/admin/AdminIdeasFormPage';
import { AdminGoalsPage } from './pages/admin/AdminGoalsPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { PaymentFailPage } from './pages/PaymentFailPage';

export const router = createBrowserRouter([
  {
    element: (
      <RequireAuth>
        <RequireConsent>
          <Outlet />
        </RequireConsent>
      </RequireAuth>
    ),
    children: [
      {
        path: '/',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <HomePage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/onboarding',
        element: (
          <RedirectByOnboarding requireNotOnboarded>
            <OnboardingPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/ideas',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <IdeasPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/ideas/:id',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <IdeaDetailPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/sessions/new',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <SessionDispatchPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/sessions/:id',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <SessionPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/history',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <HistoryPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/uniq',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <UniqPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/balance',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <BalancePage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/payment/success',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <PaymentSuccessPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/payment/fail',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <PaymentFailPage />
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/admin',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <AdminGuard>
              <AdminDashboard />
            </AdminGuard>
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/admin/ideas',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <AdminGuard>
              <AdminIdeasPage />
            </AdminGuard>
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/admin/ideas/new',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <AdminGuard>
              <AdminIdeasFormPage />
            </AdminGuard>
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/admin/ideas/:id/edit',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <AdminGuard>
              <AdminIdeasFormPage />
            </AdminGuard>
          </RedirectByOnboarding>
        ),
      },
      {
        path: '/admin/goals',
        element: (
          <RedirectByOnboarding requireOnboarded>
            <AdminGuard>
              <AdminGoalsPage />
            </AdminGuard>
          </RedirectByOnboarding>
        ),
      },
    ],
  },
]);
